module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAYBAMAAAAMkBB4AAAAKlBMVEUAAAD/aZb/aY/6aZH7aY/8aZD9aY/9aZD7aY/8aY/8aY/8aY/9aY/8aY+EXJgPAAAADnRSTlMAESIzRFVmd4iZqrvM3UwhkGcAAACYSURBVBjTY2Dw3Q0BVxgYGEoZICAciFugbA8g3sDiAgIO3CA2ezkIFIDZUDVANnMDlM1hwMBakA5WU8YewMDuYALW68xSwMCpAFXDNAGkBQo2MHCzQd2QsIFBCi6+kMEdzi5hSIOz0xhqIK4Fuvw4UIYhHcguYwCqBrJlBBgYD0LZzJsZrA2gbAbN3ZMYYGwIwM2u2Q0DxwFlEDZCoR1H0QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/serv-hover.png
// module id = 248
// module chunks = 0